import { BaseButtonWidgetRenderer } from './base-button-widget-renderer';
import { NavButtonWidgetJsonData, WidgetRenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';
import { NavDirection, normalizeNavDirection } from '../../utils/nav-direction.utils';

export class NavButtonWidgetRenderer extends BaseButtonWidgetRenderer<NavButtonWidgetJsonData> {
    protected override get defaultData(): NavButtonWidgetJsonData {
        return {
            id: '',
            type: 'navbutton',
            direction: 'next',
            label: TranslateUtils.SUBMIT_WIDGET.NEXT_LABEL,
            height: NavButtonWidgetRenderer.defaultButtonHeight
        };
    }

    public override createNew(options?: WidgetRenderOptions & { direction?: NavButtonWidgetJsonData['direction'] }): HTMLElement {
        const defaultData = super.createDefaultData();

        if (options?.direction) {
            const direction = normalizeNavDirection(options.direction);
            defaultData.direction = direction;
            defaultData.label = this.getDefaultLabel(direction);
        }

        return this.render(defaultData, options);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderContent(widgetJsonData: NavButtonWidgetJsonData, options: WidgetRenderOptions): HTMLElement {
        const content = document.createElement('div');
        content.classList.add('element-content');

        const direction = this.normalizeDirection(widgetJsonData.direction);
        content.appendChild(this.createButton(direction, widgetJsonData.label || this.getDefaultLabel(direction)));

        return content;
    }

    protected override applyAdditionalAttributes(element: HTMLElement, widgetJsonData: NavButtonWidgetJsonData): void {
        super.applyAdditionalAttributes(element, widgetJsonData);

        const direction = this.normalizeDirection(widgetJsonData.direction);

        element.dataset['buttonRole'] = direction;
        this.applyButtonElementAttributes(element, widgetJsonData.height);
    }

    // The wire format is lowercase strings on every client path (Web.Api Shared
    // models, Web.Host presenter); the shared normalizer additionally tolerates the
    // numeric Domain representation and odd casing — see nav-direction.utils.ts
    private normalizeDirection(direction: NavButtonWidgetJsonData['direction']): NavDirection {
        return normalizeNavDirection(direction);
    }

    private getDefaultLabel(direction: NavDirection): string {
        return direction === 'previous'
            ? TranslateUtils.SUBMIT_WIDGET.PREVIOUS_LABEL
            : TranslateUtils.SUBMIT_WIDGET.NEXT_LABEL;
    }
}
